const getTrucateObject = (displayKey, key, value) => ({
	displayKey,
	key,
	value,
});

function mapTestResponseToModalView(response, fieldMap) {
	const result = [];
	if (fieldMap) {
		Object.keys(response).forEach((itemKey) => {
			const itemName = response[itemKey];
			if (!itemName || Object.entries(itemName).length === 0) {
				return;
			}
			const subflowOutputField = fieldMap.find((input) => itemKey === String(input.uuid));
			const name = subflowOutputField?.name;
			if (name) {
				result.push(getTrucateObject(name, name, itemName));
			}
		});
	}

	return result;
}

const TestModalService = {
	mapTestResponseToModalView,
};

export default TestModalService;
